<template>
  <div class="container">
    <!-- header -->
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" class="navbar" />
    <!-- body -->
    <cube-scroll ref="scroll" class="scroll-wrap">
      <div class="form">
        <h2 class="title">基础信息</h2>
        <van-cell-group>
          <van-field v-model="form.title" required label="名称" placeholder="请输入名称" />
          <van-field v-model="form.price" label="价格" placeholder="请输入价格" required />
          <van-cell title="显示">
            <template slot="default">
              <van-switch v-model="form.status" slot="button" size="24px" />
            </template>
          </van-cell>
        </van-cell-group>

        <div class="submit-container">
          <van-button v-if="!spec_id" size="large" type="info" class="submit-btn" @click="onPost">提交</van-button>
          <van-button
            v-else
            size="large"
            :disabled="disabled"
            type="info"
            class="submit-btn"
            @click="onPost"
          >保存</van-button>
        </div>
      </div>
    </cube-scroll>
  </div>
</template>
<script>
import { SpecModel } from "@models/admin/spec";
import { ERR_OK } from "@/common";

const specModel = new SpecModel();
export default {
  data() {
    return {
      spec_id: "",
      title: "添加规格",
      form: {
        title: "",
        price: "",
        status: true
      },
      errmsg: {
        specnameErrorMsg: "请输入规格名称",
        specpriceErrorMsg: "请输入规格价格"
      },
      disabled: false
    };
  },
  methods: {
    onClickLeft() {
      this.$redirect("/admin/spec");
    },
    onPost() {
      if (this._checkForm() && !this.disabled) {
        this.disabled = true;
        specModel
          .post({
            formData: this.form,
            user_token: localStorage.getItem("user_token")
          })
          .then(res => {
            if (res.code == ERR_OK) {
              if (!this.spec_id) {
                this.$dialog
                  .confirm({
                    message: "添加成功",
                    cancelButtonText: "继续添加",
                    confirmButtonText: "返回列表"
                  })
                  .then(() => {
                    this.$setCache("event", "add");
                    this.$redirect("/admin/spec");
                    this.disabled = false;
                  })
                  .catch(() => {
                    this._resetForm();
                  });
              } else {
                this.$setCache("spec_data", this.form);
                this.$setCache("event", "update");
                this.$setCache("data_name", "spec_data");
                this.$toast("修改成功!");
                setTimeout(() => {
                  this.$redirect("/admin/spec");
                  this.disabled = false;
                }, 3000);
              }
            } else {
              this.$toast(res.msg);
              this.disabled = false;
            }
          });
      }
    },
    _resetForm() {
      this.form = {
        title: "",
        price: "",
        status: true
      };
      this.disabled = false;
    },
    _checkForm() {
      if (!this.form.title) {
        this.$toast(this.errmsg.specnameErrorMsg);
        return false;
      }
      if (!this.form.price) {
        this.$toast(this.errmsg.specpriceErrorMsg);
        return false;
      }
      return true;
    },
    getData(name) {
      this.spec_id = this.$route.query.id;
      if (this.$route.query.id) {
        let spec_data = this.$getCache(name);
        spec_data.status = spec_data.status == 1 ? true : false;
        Object.assign(this.form, spec_data);
      } else {
        this.$delCache(name);
      }
    },
    setPlaceholder() {
      if (this.$route.query.id) {
        this.title = "编辑规格";
      } else {
        this.title = "添加规格";
        this._resetForm();
      }
    }
  },

  activated() {
    this.getData("spec_data");
    this.setPlaceholder();
    console.log(this.form);
  }
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}

.scroll-wrap {
  height: calc(100% - 0.92rem);
  position: fixed;
  top: 0.92rem;
  width: 100%;
}

.vanarea {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.navbar {
  color: #fff;
  background: #2196f3;
  position: fixed;
  top: 0;
  width: 100%;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

.form .title {
  padding: 0.4rem 0.3rem;
  font-size: 0.28rem;
  color: rgba(69, 90, 100, 0.49);
}

.submit-container {
  display: flex;
  padding: 0.6rem 0.2rem;
}

.submit-container .submit-btn {
  border-radius: 4px;
}
</style>
